export default __webpack_public_path__ + "static/media/back-24.0908efff.svg";